




































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import CountryFlag from 'vue-country-flag';
import VueToExcel from 'vue-json-excel';
import ContractService from '@/domain/contract/service/contract.service';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import DateHandler from '@/shared/utils/date-format';
import PushOrderUtils from '@/shared/utils/push-order-utils';
import PushOrderInfo from '@/components/push-order/push-order-info.component.vue';
import EventBus, { Event } from '@/event.bus'
import Pagination from '@/domain/pagination.entity';
import toDocument from '@/shared/directive/toDocument';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import splitContent from '@/shared/directive/split-content';
import routeTo from '@/router/routeTo'
import AuthorityService from '@/domain/security/authority.service';
import BillingModalError from '@/shared/billing-error/billing-modal-error.component.vue';
import ContractList from '@/domain/contract/entity/contract-list.entity';
import ContractItemRuleReport from '@/domain/contract/entity/contract-item-rule-report.entity';
import ContractFilter from '@/domain/contract/entity/contract-filter.entity';
import Response from '@/domain/response.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ContractPlanReport from '@/domain/contract/entity/contract-plan-report.entity';
import ContractItemBillingReport from '@/domain/contract/entity/contract-item-billing-report.entity';
import BillingService from '@/domain/billing/service/billing.service';
import TaskService from '@/domain/task/task.service';
import ContractBillingDailyModal from '../contract-modal/contract-billing-daily-modal.component.vue';
import ContractExecuteBillingModal from '../contract-modal/contract-billing-modal-execute.component.vue';
import BillingModalPushOrderRequest from '../contract-info/billing-modal-push-order-request.component.vue';
import FilterComponent from './contract-filter.component.vue';
import Header from './header.json';
import ContractExportOptions from './contract-export-options.json';

@Component({
  name: 'ContractDataTable',
  components: {
    FilterComponent,
    VbPagination,
    VbTooltipSlot,
    VueToExcel,
    ContractExecuteBillingModal,
    BillingModalError,
    CountryFlag,
    ContractBillingDailyModal,
    PushOrderInfo,
    BillingModalPushOrderRequest,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value);
    },
    toDocument,
    splitContent,
  },
})

export default class ContractDataTable extends Vue {
  showFilter: boolean = false;

  header = Header;

  filter: ContractFilter = new ContractFilter({});

  loading: boolean = true;

  searching: boolean = false;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'customer.name|asc',
  });

  contracts: ContractList[] = [];

  businessUnitId: string = '';

  inconsistentContractMessage = `Contrato não possui cálculo configurado
   ou instância cadastrada ou data de início de faturamento ou o contrato é uma prévia.`;

  hasAdministratorAuthority: boolean = false;

  showExecuteBillingModal: boolean = false;

  showBillingModalError: boolean = false;

  executeBillingModalKey: number = 10;

  executionError: boolean = false;

  competenceSuccess: string = '';

  showSuccessLog: boolean = false;

  contractExportOptions = ContractExportOptions;

  billingDaily: boolean = false;

  showExecuteBillingDailyModal: boolean = false;

  loadingBillingDaily: boolean = false;

  showModalInfo: boolean = false;

  modalInfoMessage: string = '';

  showModalBilling: boolean = false;

  showModalPushOrderPendence: boolean = false;

  pushOrderPendence: number = 0;

  selectedCompetence: string = '';

  validateAuthority(): void {
    AuthorityService.authorities().then((response) => {
      if (response.includes('ADMINISTRATOR')) {
        this.hasAdministratorAuthority = true;
      }
    });
  }

  checkAndApplyUrlFilter(): void {
    const initialFilter = this.getInitialFilter()
    this.applyFilter(initialFilter);
  }

  created() {
    this.validateAuthority();
    this.checkAndApplyUrlFilter();
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    this.billingDaily = UserBusinessUnitService.currentBusinessUnit.billingDaily;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && (this.$route.name.includes('Contratos') || this.$route.name.includes('ContractDataTable'))) {
        this.businessUnitId = businessUnit.id;
        this.pagination.page = 1
        this.billingDaily = businessUnit.billingDaily;
        this.findContracts(this.filter);
      }
    });
    this.findContracts(this.filter);
  }

  getInitialFilter() {
    const params = {
      contract: this.$route.query.contract || '',
      periodStart: this.$route.query.periodStart || '',
      periodEnd: this.$route.query.periodEnd || '',
      customerIds: this.$route.query.customerIds || [],
      customerDocument: this.$route.query.customerDocument || '',
      status: this.$route.query.status ? this.$route.query.status.toString().toUpperCase() : '',
      competenceFilter: this.$route.query.status ? this.$route.query.competenceFilter : '',
      selectedDates: this.$route.query.selectedDates || [],
      expiresAtDates: this.$route.query.expiresAtDates || [],
      anniversary: this.$route.query.anniversary || '',
      externalId: this.$route.query.externalId || '',
      instanceCode: this.$route.query.instanceCode || '',
      resultCenterId: this.$route.query.resultCenterId || '',
      isBillingEnabled: this.$route.query.isBillingEnabled || false,
      beneficiary: this.$route.query.beneficiary || '',
      expiresAtStart: this.$route.query.expiresAtStart || '',
      expiresAtEnd: this.$route.query.expiresAtEnd || '',
      markedToExpire: this.$route.query.markedToExpire || null,
      productIds: this.$route.query.productIds || null,
    }
    return ContractFilter.of(params)
  }

  applyFilter(filter: ContractFilter) {
    this.$route.params.status = filter.status;
    this.filter = ContractFilter.of(filter);
    this.filter.prepareToSend();
    this.pagination.page = 1;
    this.findContracts(this.filter);
  }

  findContracts(filter: ContractFilter) {
    if (this.searching) {
      return;
    }
    if (this.businessUnitId) {
      this.loading = true;
      this.searching = true;
      ContractService.filter(this.pagination, this.businessUnitId, filter)
        .then((response: Response) => {
          this.contracts = ContractList.ofList(response.content)
          this.pagination.total = response.totalElements;
          this.pagination.pageCount = response.totalPages;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => {
          this.loading = false;
          this.searching = false;
        });
    }
  }

  updateTable(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findContracts(this.filter);
  }

  selectContract(value: string) {
    const route: any = {
      name: 'Contrato',
      params: {
        id: value,
      },
    };
    routeTo(this.$router, route)
  }

  private getDistinctValues(value: string): string {
    if (!value) return '';
    const arrayValues = value.split(', ');
    const distinctResultCenters: string[] = [];
    arrayValues.forEach((el: string): void => {
      if (!distinctResultCenters.includes(el)) {
        distinctResultCenters.push(el);
      }
    });
    return distinctResultCenters.join(', ');
  }

  findContractsExportToXLS(): Promise<ContractList[]> {
    const pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    return ContractService.filter(pagination, this.businessUnitId, this.filter)
      .then((response: Response) => {
        const content = response.content.map((item) => ({
          ...item,
          customerDocument: toDocument(item.customerDocument),
          resultCenter: this.getDistinctValues(item.resultCenter),
        }));
        return ContractList.ofList(content);
      });
  }

  exportToXLSOptionsFetch = {
    exportListContract: () => (
      this.findContractsExportToXLS()
    ),
    exportContractItemRuleReport: () => (
      this.filterContractItemRuleReport()
    ),
    exportContractPlanReport: () => (
      this.filterContractPlanReport()
    ),
    exportContractItemBillingReport: () => (
      this.filterContractItemBillingReport()
    ),
  }

  async filterContractItemRuleReport(): Promise<ContractItemRuleReport[]> {
    const pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    const response = await ContractService.filterContractItemRuleReport(
      this.businessUnitId,
      this.filter,
    );
    const content = response.map((item) => ({
      ...item,
      customerDocument: toDocument(item.customerDocument),
      resultCenter: this.getDistinctValues(item.resultCenter),
    }));
    return ContractItemRuleReport.ofList(content);
  }

  async filterContractPlanReport(): Promise<ContractPlanReport[]> {
    const pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    const response = await ContractService.filterContractPlanReport(
      this.businessUnitId,
      this.filter,
    );
    const content = response.map((item) => ({
      ...item,
      customerDocument: toDocument(item.customerDocument),
      resultCenter: this.getDistinctValues(item.resultCenter),
    }));
    return ContractPlanReport.ofList(content);
  }

  async filterContractItemBillingReport(): Promise<ContractItemBillingReport[]> {
    const pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    const response = await ContractService.filterContractItemBillingReport(
      this.businessUnitId,
      this.filter,
    );
    const content = response.map((item) => ({
      ...item,
      customerDocument: toDocument(item.customerDocument),
      resultCenter: this.getDistinctValues(item.resultCenter),
    }));
    return ContractItemBillingReport.ofList(content);
  }

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  confirmSuccess(): void {
    this.closeSuccessLog();
  }

  closeSuccessLog(): void {
    this.showSuccessLog = false;
  }

  private showExecuteBilling(): void {
    const stateModalBilling = !this.showExecuteBillingModal;
    this.updateExecuteBillingModalState(stateModalBilling);
  }

  updateExecuteBillingModalState(value: boolean): void {
    if (value) {
      this.executeBillingModalKey += 1;
    }
    this.showExecuteBillingModal = value;
  }

  handleExecutionSuccess(competence: string) {
    this.competenceSuccess = competence;
    this.showSuccessLog = true;
  }

  handleExecutionError() {
    this.showBillingModalError = true;
    this.executionError = true;
  }

  filterContractByCompetence(): void {
    const competence = this.competenceSuccess
    const filter: ContractFilter = ContractFilter.of({ competence });
    this.applyFilter(filter);
    this.closeSuccessLog();
  }

  get exportTooltipMessage() {
    return !this.contracts.length ? 'Nenhum dado encontrado para exportação' : 'Exportar'
  }

  get btnExportColor() {
    return !this.contracts.length ? 'grayPrimary' : 'bluePrimary'
  }

  async checkHasPushOrderPendences(): Promise<boolean> {
    const filter: ContractFilter = ContractFilter.of({});
    filter.status = 'PUSH_ORDER_REQUIRED_BUT_ABSENT';
    const content: any = [];
    await ContractService.filter(this.pagination, this.businessUnitId, filter)
      .then((response: any) => {
        content.push(...response.content);
        this.pushOrderPendence = content.length;
      });
    return content.length > 0;
  }

  async handleBillingDaily(competence: string): Promise<void> {
    this.loadingBillingDaily = true;
    this.selectedCompetence = competence;
    if (await this.checkHasPushOrderPendences()) {
      this.showModalPushOrderPendence = true;
      this.loadingBillingDaily = false;
      return;
    }
    this.executeBillingDaily(competence);
  }

  executeBillingDaily(competence: string): void {
    this.loadingBillingDaily = true;
    BillingService.executeBilling({
      businessUnitId: this.businessUnitId,
      invoiceCompetence: competence,
      billingDaily: true,
    })
      .then((taskId: string) => {
        this.handleExecuteBilling(taskId);
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
        this.loadingBillingDaily = false;
      })
  }

  handleExecuteBilling(taskId: string) {
    TaskService.getTask(taskId, 10000)
      .then(() => {
        this.handleExecutionSuccess(this.competenceSuccess)
        this.showExecuteBillingDailyModal = false;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingBillingDaily = false);
  }

  showModalToBilling() {
    this.showModalBilling = true;
  }

  closeModalBilling() {
    this.showModalBilling = false;
  }
}

